// extracted by mini-css-extract-plugin
export default {"input":"_base-input-text_input_ciPUe"};